import React, { useEffect, useState } from "react";
import { Dialog } from "../../../Dialogs/Dialog";
import {
  Button,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Divider,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import {
  CustomFormLabel,
  CustomShrinkTextField,
} from "../../../formsComponents";
import { AutoComplete } from "../../../AutoCompleteSearches/AutoComplete";
import { useDispatchWrapper } from "../../../../hooks";
import { ISelectOption } from "../../../../constants/types";
import { fetchTemplateModuleSubModuleAsync } from "../../../../redux/templates";

export interface TableColumnDef {
  tableName: string;
  columnName: string;
  list: {
    tableHeaderName: string;
    subColumnName: string;
  }[];
}

interface ILoopDialogProps {
  open: boolean;
  widgetId?: string;
  initialColumns?: TableColumnDef;
  onClose: () => void;
  onInsert: (text: string, isEdit?: boolean, uniqueId?: string) => void;
}

export const LoopDialog: React.FC<ILoopDialogProps> = ({
  open,
  onClose,
  onInsert,
  widgetId: widgetIdFromWidget,
  initialColumns,
}) => {
  const [columns, setColumns] = useState<TableColumnDef>({
    tableName: "",
    columnName: "",
    list: [],
  });
  const [state, setState] = useState({
    tableHeaderName: "",
    subColumnName: "",
  });
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [tables, setTables] = React.useState<ISelectOption[]>([]);
    const [columnNames, setColumnNames] = React.useState<ISelectOption[]>([]);
  const dispatch = useDispatchWrapper();

  useEffect(() => {
    if (initialColumns) {
      setColumns(initialColumns);
    }
  }, [initialColumns]);

  const handleAdd = () => {
    if (!state.tableHeaderName.trim() || !state.subColumnName.trim()) return;
    if (editIndex !== null) {
      const updated = { ...columns };
      updated.list[editIndex] = {
        tableHeaderName: state.tableHeaderName,
        subColumnName: state.subColumnName,
      };
      setColumns(updated);
      setEditIndex(null);
    } else {
      setColumns({
        ...columns,
        list: [
          ...columns.list,
          {
            tableHeaderName: state.tableHeaderName,
            subColumnName: state.subColumnName,
          },
        ],
      });
    }
    setState({
      tableHeaderName: "",
      subColumnName: "",
    });
  };

  const handleEdit = (index: number) => {
    const item = columns.list[index];
    setState({
      tableHeaderName: item.tableHeaderName,
      subColumnName: item.subColumnName,
    });
    setEditIndex(index);
  };

  const handleDelete = (index: number) => {
    setColumns({
      ...columns,
      list: columns.list.filter((_, i) => i !== index),
    });
    if (editIndex === index) {
      setState({ tableHeaderName: "", subColumnName: "" });
      setEditIndex(null);
    }
  };

  const handleSave = () => {
    if (columns.list.length === 0 || !columns.tableName || !columns.columnName) {
      onClose();
      return;
    }

    const widgetId = `widget-${Date.now()}`;

    const tableHtml = `
      <table 
        class="custom-widget-table" 
        data-widget-id="${widgetIdFromWidget || widgetId}" 
        data-columns='${JSON.stringify(columns)}'
      >
        <thead>
          <tr>
            ${columns.list
              .map((col) => `<th>${col.tableHeaderName}</th>`)
              .join("")}
          </tr>
        </thead>
        <tbody>
        @@startLoop1(data.${columns.tableName}.${columns.columnName})
        <tr style="height: 31.2px;">
         ${columns.list.map((item) => {
           return `<td>@@data.${columns.tableName}.${columns.columnName}[].${item.subColumnName}</td>`;
         })}
        </tr>
        @@endLoop1
        </tbody>
         
      </table>
    `;

    onInsert(
      tableHtml,
      initialColumns ? initialColumns.list.length > 0 : false,
      widgetIdFromWidget || widgetId
    );
    onClose();
  };

  React.useEffect(() => {
    setTables([]);
    dispatch(
      fetchTemplateModuleSubModuleAsync((modules) => {
        setTables(modules);
      })
    );
  }, []);


    React.useEffect(() => {
     
     
      if(columns.tableName){
          dispatch(
          fetchTemplateModuleSubModuleAsync((modules) => {
            setColumnNames(modules);
          }, columns.tableName)
        );
      
      }
    }, [columns.tableName]);
  

  return (
    <Dialog
      open={open}
      size="md"
      title="Loop"
      onClose={onClose}
      actions={[
        {
          type: "button",
          label: "Close",
          variant: "text",
          onClick: onClose,
        },
        {
          type: "button",
          label: "Save",
          variant: "contained",
          onClick: handleSave,
        },
      ]}
    >
      <Grid container spacing={2} >
        <Grid item xs={12} md={6}>
          <CustomFormLabel>Table Name</CustomFormLabel>
          <AutoComplete
            value={columns.tableName}
            onChange={(newValue) =>
              setColumns({ ...columns, tableName: newValue })
            }
            placeholder="Select one"
            options={tables.map((table) => {
              return {
                label: table.label,
                value: table.value as string,
              };
            })}
          ></AutoComplete>
        </Grid>
        <Grid item xs={12} md={6}>
          <CustomFormLabel>Column Name</CustomFormLabel>
          <AutoComplete
            value={columns.tableName}
            onChange={(newValue) =>
              setColumns({ ...columns, columnName: newValue })
            }
            placeholder="Select one"
            options={columnNames.map((table) => {
              return {
                label: table.label,
                value: table.value as string,
              };
            })}
          ></AutoComplete>
        </Grid>
      </Grid>

      <Divider sx={{mt: 2,mb: 2}}/>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack direction={"row"} spacing={2}>
            <CustomShrinkTextField
              label="Table Column Name"
              value={state.tableHeaderName}
              onChange={(e) => setState({...state, tableHeaderName: e.target.value})}
              fullWidth
              size="small"
            />
            <CustomShrinkTextField
              label="Column"
              value={state.subColumnName}
              //onChange={(e) => setColumnName(e.target.value)}
                onChange={(e) => setState({...state, subColumnName: e.target.value})}
              fullWidth
              size="small"
            />
          

            <Button variant="contained" size="medium" onClick={handleAdd}>
              {editIndex !== null ? "Update" : "Add"}
            </Button>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          {columns.list.length > 0 && (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>Column Name</TableCell>
                  <TableCell>Mapped Column</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {columns.list.map((col, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{col.tableHeaderName}</TableCell>
                    <TableCell>{`@@data.${columns.tableName}.${columns.columnName}[].${col.subColumnName}`}</TableCell>

                    <TableCell align="right">
                      <IconButton onClick={() => handleEdit(index)}>
                        <Edit fontSize="small" />
                      </IconButton>
                      <IconButton onClick={() => handleDelete(index)}>
                        <Delete fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Grid>
      </Grid>
    </Dialog>
  );
};